// extracted by mini-css-extract-plugin
export default {"wrapper":"ManagersPane_wrapper__SzUpL"};